import React from "react";
import TalkToOurTeamBTN from "../Coman/TalkToOurTeamBTN";

export default function NFTWalletHero() {
  return (
    <>
      <section
        className="feature-section py_150"
        aria-label="NFT-Wallet-Development-Hero-Section-Image-File"
        style={{
          backgroundPosition: "50% 50%",
          backgroundSize: "cover",
          backgroundImage:
            "url(assets/img/wallet/NFT-Wallet-Development-Hero-Section-Image-File.jpg)",
        }}
      >
        <div className="auto-container py-5">
          <div className="row align-items-center py-5">
            <div className="col-lg-6 col-md-12 col-sm-12 content-column">
              <div className="content-box mr_40">
                <div data-animation-box className="sec-title mb_25">
                  <h2 className="text-white">NFT Wallet Development</h2>
                </div>
                <div className="text-box">
                  <p className="text-white">
                    Empower your users with a custom NFT wallet that offers
                    secure storage, easy transactions, and full control over
                    their digital assets. Whether you’re developing for
                    Ethereum, Solana, or any blockchain, our expert team will
                    create a tailored solution that integrates seamlessly with
                    your ecosystem.
                  </p>
                </div>
                <TalkToOurTeamBTN />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 image-column"></div>
          </div>
        </div>
      </section>
    </>
  );
}
